import React from "react";
import { CheckCircle2, Clock3, XCircle, BadgeCheck } from "lucide-react";
import { prettyLabel, statusTone } from "@/lib/propertyUi";

const COMPACT_LABELS = {
  PENDING_SOLD_VERIFICATION: "Pending Sold",
  PENDING_VERIFICATION: "Pending Verif",
  UNDER_REVIEW: "In Review",
  PUBLISHED: "Published",
  ACTIVE: "Active",
  APPROVED: "Approved",
  DRAFT: "Draft",
  SOLD: "Sold",
  REJECTED: "Rejected",
};

const TOOLTIPS = {
  PENDING_SOLD_VERIFICATION: "Sold state is pending admin verification",
  PENDING_VERIFICATION: "Listing is pending office verification",
  UNDER_REVIEW: "Listing is currently under review by office moderators",
  PUBLISHED: "Listing is live and visible to the public",
  ACTIVE: "Listing is active and accepting inquiries",
  APPROVED: "Listing documents have been approved",
  DRAFT: "Listing is in draft mode and not yet submitted",
  SOLD: "Property has been sold successfully",
  REJECTED: "Listing has been rejected by moderators",
};

export default function StatusBadge({ status, children }) {
  const statusKey = String(status || "").toUpperCase();
  const tone = statusTone(status);
  const isSold = statusKey === "SOLD";
  const Icon = isSold ? BadgeCheck : tone === "emerald" ? CheckCircle2 : tone === "rose" ? XCircle : Clock3;
  
  const cls = tone === "emerald"
    ? "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-950/20 dark:text-emerald-400 dark:border-emerald-800/35"
    : tone === "rose"
    ? "bg-rose-50 text-rose-700 border-rose-200 dark:bg-rose-950/20 dark:text-rose-400 dark:border-rose-800/35"
    : tone === "amber"
    ? "bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-950/20 dark:text-amber-400 dark:border-amber-800/35"
    : "bg-slate-50 text-slate-700 border-slate-200 dark:bg-slate-900/50 dark:text-slate-400 dark:border-slate-800/35";

  const displayLabel = children || COMPACT_LABELS[statusKey] || prettyLabel(status || "Draft");
  const tooltipText = TOOLTIPS[statusKey] || `${prettyLabel(status || "Draft")} Status`;

  return (
    <span 
      title={tooltipText}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[11px] font-bold uppercase tracking-wider cursor-help transition-all shadow-sm ${cls}`}
    >
      <Icon className="w-3.5 h-3.5" /> {displayLabel}
    </span>
  );
}

